export default __webpack_public_path__ + "static/media/gr.ff92aa39.jpg";